<header class="header">
    <div class="container">

        <a (click)="goBack()" class="navbar-brand logo">
            <img src="assets/images/ToT-Light-Logo.png" alt="TutorOnTip Logo" />
        </a>

    </div>
</header>